import {
    createImageGalleryComponent,
    ImageGallery,
} from '@vfde-brix/image-gallery';

/**
 * Mount image gallery component
 * @param container
 * @param images
 */
const mountImageGallery = (container, images): ImageGallery => {
    const containerEle = document.getElementById(container) as HTMLElement;
    const items = [];
    for (const image of images) {
        items.push({
            imgSrc: image,
        });
    }

    return createImageGalleryComponent(containerEle, {
        items,
        business: {},
    });
};

export default mountImageGallery;
